import { Link } from 'react-router-dom';
import { useTranslation } from '@most/i18n';
import { Button, EmptyState } from '@most/ui';
import { Ban, KeyRound, Lock, SearchX } from 'lucide-react';

/**
 * Role mismatch. An in-app 403 with a link home — deliberately NOT a redirect and deliberately
 * not a 404: it must never leak whether the route it refused actually exists (docs/06 §3).
 */
export function Forbidden() {
  const { t } = useTranslation('common');
  return (
    <div className="mx-auto max-w-md px-4 py-24">
      <EmptyState
        icon={<Lock className="h-8 w-8" />}
        title={t('states.forbiddenTitle')}
        description={t('states.forbiddenBody')}
        action={
          <Button asChild variant="outline">
            <Link to="/catalog">{t('states.goHome')}</Link>
          </Button>
        }
      />
    </div>
  );
}

/**
 * `status = blocked`. The session was already revoked server-side; this is the neutral copy the
 * SPA shows to the stale client. It says nothing about WHY — that conversation is Merdan's.
 */
export function AccountUnavailable() {
  return (
    <div className="mx-auto max-w-md px-4 py-24">
      <EmptyState
        icon={<Ban className="h-8 w-8" />}
        title="Аккаунт недоступен"
        description="Свяжитесь с MOST."
      />
    </div>
  );
}

/** Admin-created accounts hold a temporary password and must change it before anything else. */
export function MustChangePassword() {
  const { t } = useTranslation('auth');
  return (
    <div className="mx-auto max-w-md px-4 py-24">
      <EmptyState
        icon={<KeyRound className="h-8 w-8" />}
        title={t('session.mustChangePassword')}
        action={
          <Button asChild>
            <Link to="/profile">Сменить пароль</Link>
          </Button>
        }
      />
    </div>
  );
}

export function NotFound() {
  const { t } = useTranslation('common');
  return (
    <div className="mx-auto max-w-md px-4 py-24">
      <EmptyState
        icon={<SearchX className="h-8 w-8" />}
        title={t('states.notFoundTitle')}
        description={t('states.notFoundBody')}
        action={
          <Button asChild variant="outline">
            <Link to="/catalog">{t('states.goHome')}</Link>
          </Button>
        }
      />
    </div>
  );
}
